(() => {
  'use strict';

  /* ==========================================
     OZON EXPRESS CITY SELECTOR
     Target: <input id="es-city" ...>
     ========================================== */

  const API = 'https://api.ozonexpress.ma/cities';
  const SELECTOR = '#es-city';

  let cities = [];
  let loading = null;

  /* ---------- HELPERS ---------- */

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* ---------- LOAD OZON CITIES ---------- */

  function loadCities() {
    if (cities.length) {
      return Promise.resolve(cities);
    }

    if (loading) {
      return loading;
    }

    loading = fetch(API, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        return response.json();
      })
      .then(data => {
        if (!data || !data.CITIES) {
          throw new Error('CITIES not found');
        }

        cities = Object.values(data.CITIES)
          .map(city => ({
            id: city.ID,
            ref: city.REF || '',
            name: String(city.NAME || '').trim(),
            price: Number(city['DELIVERED-PRICE'] || 0)
          }))
          .filter(city => city.id && city.name)
          .sort((a, b) =>
            a.name.localeCompare(b.name, 'fr', {
              sensitivity: 'base'
            })
          );

        return cities;
      })
      .catch(error => {
        loading = null;
        console.error('[Ozon Cities]', error);
        throw error;
      });

    return loading;
  }

  /* ---------- CSS ---------- */

  function addCSS() {
    if (document.getElementById('ozon-es-city-css')) {
      return;
    }

    const style = document.createElement('style');

    style.id = 'ozon-es-city-css';

    style.textContent = `

      /* Wrapper autour du champ Ville */

      .ozon-es-city-wrapper {
        position: relative !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }


      /* Input */

      #es-city {
        padding-right: 42px !important;
        box-sizing: border-box !important;
      }


      /* Champ invalide */

      #es-city.ozon-city-invalid {
        border: 2px solid #e11919 !important;
        outline: none !important;
        box-shadow: none !important;
      }


      /* Flèche */

      .ozon-city-arrow {
        position: absolute !important;

        right: 6px !important;
        top: 50% !important;

        transform: translateY(-50%) !important;

        width: 34px !important;
        height: 34px !important;

        padding: 0 !important;
        margin: 0 !important;

        border: 0 !important;
        outline: 0 !important;

        background: transparent !important;
        box-shadow: none !important;

        cursor: pointer !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        z-index: 1002 !important;

        appearance: none !important;
        -webkit-appearance: none !important;
      }


      .ozon-city-arrow:hover,
      .ozon-city-arrow:focus,
      .ozon-city-arrow:active {
        background: transparent !important;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
      }


      .ozon-city-arrow svg {
        display: block !important;

        width: 16px !important;
        height: 16px !important;

        fill: none !important;

        stroke: #666 !important;
        stroke-width: 1.8 !important;

        stroke-linecap: round !important;
        stroke-linejoin: round !important;

        transition: transform .2s ease !important;

        pointer-events: none !important;
      }


      .ozon-es-city-wrapper.ozon-open
      .ozon-city-arrow svg {
        transform: rotate(180deg) !important;
      }


      /* Dropdown */

      .ozon-city-dropdown {
        position: absolute !important;

        top: calc(100% + 4px) !important;
        left: 0 !important;
        right: 0 !important;

        width: 100% !important;
        min-width: 100% !important;
        max-width: 100% !important;

        box-sizing: border-box !important;

        background: #ffffff !important;

        border: 1px solid #bcbcbc !important;
        border-radius: 6px !important;

        box-shadow:
          0 8px 20px rgba(0, 0, 0, .14) !important;

        max-height: 250px !important;

        overflow-y: auto !important;
        overflow-x: hidden !important;

        z-index: 999999999 !important;

        display: none !important;
      }


      .ozon-city-dropdown.open {
        display: block !important;
      }


      /* Ville */

      .ozon-city-option {
        display: flex !important;
        align-items: center !important;

        width: 100% !important;
        min-height: 43px !important;

        padding: 10px 13px !important;
        margin: 0 !important;

        box-sizing: border-box !important;

        background: #ffffff !important;
        color: #111111 !important;

        border: 0 !important;
        border-bottom: 1px solid #d5d5d5 !important;

        border-radius: 0 !important;

        cursor: pointer !important;

        font-family: inherit !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 1.4 !important;
      }


      .ozon-city-option:last-child {
        border-bottom: 0 !important;
      }


      .ozon-city-option:hover,
      .ozon-city-option.active {
        background: #f3f3f3 !important;
      }


      .ozon-city-name {
        display: block !important;

        width: 100% !important;

        padding: 0 !important;
        margin: 0 !important;

        color: #111111 !important;

        white-space: normal !important;
        word-break: break-word !important;
      }


      /* Loading / aucun résultat */

      .ozon-city-message {
        width: 100% !important;

        padding: 13px !important;

        box-sizing: border-box !important;

        background: #ffffff !important;
        color: #777777 !important;

        font-family: inherit !important;
        font-size: 13px !important;

        text-align: center !important;
      }


      /* Message erreur */

      .ozon-city-error {
        display: none !important;

        width: 100% !important;

        margin-top: 5px !important;

        padding: 0 !important;

        box-sizing: border-box !important;

        color: #e11919 !important;

        font-family: inherit !important;
        font-size: 12px !important;
        font-weight: 400 !important;
        line-height: 1.4 !important;
      }


      .ozon-city-error.show {
        display: block !important;
      }


      /* Mobile */

      @media screen and (max-width: 767px) {

        .ozon-city-dropdown {
          left: 0 !important;
          right: 0 !important;

          width: 100% !important;
          min-width: 100% !important;
          max-width: 100% !important;
        }

        .ozon-city-option {
          width: 100% !important;
          min-height: 43px !important;
        }

      }

    `;

    document.head.appendChild(style);
  }

  /* ---------- INITIALIZE FIELD ---------- */

  function init(input) {

    if (!input || input.dataset.ozonReady === '1') {
      return;
    }

    input.dataset.ozonReady = '1';
    input.dataset.ozonSelected = '0';

    input.autocomplete = 'off';
    input.required = true;

    addCSS();


    /* Create wrapper */

    const wrapper = document.createElement('div');

    wrapper.className = 'ozon-es-city-wrapper';

    input.parentNode.insertBefore(wrapper, input);

    wrapper.appendChild(input);


    /* Dropdown */

    const dropdown = document.createElement('div');

    dropdown.className = 'ozon-city-dropdown';

    wrapper.appendChild(dropdown);


    /* Arrow */

    const arrow = document.createElement('button');

    arrow.type = 'button';

    arrow.className = 'ozon-city-arrow';

    arrow.setAttribute(
      'aria-label',
      'Show cities'
    );

    arrow.setAttribute(
      'aria-expanded',
      'false'
    );

    arrow.innerHTML = `
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M5.5 7.5L10 12l4.5-4.5"></path>
      </svg>
    `;

    wrapper.appendChild(arrow);


    /* Hidden Ozon City ID */

    const hiddenId =
      document.createElement('input');

    hiddenId.type = 'hidden';
    hiddenId.name = 'ozon_city_id';
    hiddenId.className = 'ozon-city-id';

    wrapper.appendChild(hiddenId);


    /* Hidden Ozon City REF */

    const hiddenRef =
      document.createElement('input');

    hiddenRef.type = 'hidden';
    hiddenRef.name = 'ozon_city_ref';
    hiddenRef.className = 'ozon-city-ref';

    wrapper.appendChild(hiddenRef);


    /* Error */

    const errorMessage =
      document.createElement('div');

    errorMessage.className =
      'ozon-city-error';

    errorMessage.textContent =
      'Please select a city from the list.';

    wrapper.appendChild(errorMessage);


    let results = [];
    let active = -1;
    let selecting = false;


    /* ---------- OPEN / CLOSE ---------- */

    function open() {

      dropdown.classList.add('open');

      wrapper.classList.add('ozon-open');

      arrow.setAttribute(
        'aria-expanded',
        'true'
      );
    }


    function close() {

      dropdown.classList.remove('open');

      wrapper.classList.remove('ozon-open');

      arrow.setAttribute(
        'aria-expanded',
        'false'
      );

      active = -1;
    }


    /* ---------- VALIDATION ---------- */

    function hideError() {

      input.classList.remove(
        'ozon-city-invalid'
      );

      errorMessage.classList.remove(
        'show'
      );

      input.removeAttribute(
        'aria-invalid'
      );

      input.setCustomValidity('');
    }


    function showError() {

      input.classList.add(
        'ozon-city-invalid'
      );

      errorMessage.classList.add(
        'show'
      );

      input.setAttribute(
        'aria-invalid',
        'true'
      );
    }


    function invalidate() {

      hiddenId.value = '';
      hiddenRef.value = '';

      input.dataset.ozonSelected = '0';

      delete input.dataset.ozonCityId;
      delete input.dataset.ozonCityRef;
      delete input.dataset.ozonDeliveryPrice;
    }


    /* ---------- SELECT CITY ---------- */

    function select(city) {

      selecting = true;

      input.value = city.name;

      hiddenId.value =
        String(city.id);

      hiddenRef.value =
        city.ref;

      input.dataset.ozonSelected = '1';

      input.dataset.ozonCityId =
        String(city.id);

      input.dataset.ozonCityRef =
        city.ref;

      input.dataset.ozonDeliveryPrice =
        String(city.price);

      hideError();

      close();


      /*
       Notify the COD application that
       the input value changed.
      */

      input.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );


      /*
       Restore selection because some
       apps modify attributes after input/change.
      */

      input.dataset.ozonSelected = '1';

      input.dataset.ozonCityId =
        String(city.id);

      input.dataset.ozonCityRef =
        city.ref;

      input.dataset.ozonDeliveryPrice =
        String(city.price);

      hiddenId.value =
        String(city.id);

      hiddenRef.value =
        city.ref;

      selecting = false;
    }


    /* ---------- RENDER ---------- */

    function render(items) {

      results = items;

      active = -1;


      if (!items.length) {

        dropdown.innerHTML =
          '<div class="ozon-city-message">No city found</div>';

        open();

        return;
      }


      dropdown.innerHTML =
        items
          .map(
            (city, index) => `
              <div
                class="ozon-city-option"
                data-index="${index}"
              >
                <span class="ozon-city-name">
                  ${escapeHTML(city.name)}
                </span>
              </div>
            `
          )
          .join('');


      dropdown
        .querySelectorAll(
          '.ozon-city-option'
        )
        .forEach(option => {

          option.addEventListener(
            'mousedown',
            event => {

              event.preventDefault();
              event.stopPropagation();

              const index =
                Number(
                  option.dataset.index
                );

              const city =
                results[index];

              if (city) {
                select(city);
              }
            }
          );

          option.addEventListener(
            'touchend',
            event => {

              event.preventDefault();

              const index =
                Number(
                  option.dataset.index
                );

              const city =
                results[index];

              if (city) {
                select(city);
              }
            },
            {
              passive: false
            }
          );

        });


      open();
    }


    /* ---------- SHOW ALL ---------- */

    async function showAllCities() {

      dropdown.innerHTML =
        '<div class="ozon-city-message">Loading...</div>';

      open();

      try {

        await loadCities();

        const query =
          normalize(input.value);


        if (
          query &&
          input.dataset.ozonSelected !== '1'
        ) {

          const matches =
            cities
              .filter(city =>
                normalize(city.name)
                  .includes(query)
              )
              .slice(0, 100);

          render(matches);

        } else {

          render(
            cities.slice(0, 100)
          );
        }

      } catch (error) {

        dropdown.innerHTML =
          '<div class="ozon-city-message">Unable to load cities</div>';

        open();
      }
    }


    /* ---------- SEARCH ---------- */

    async function search() {

      if (selecting) {
        return;
      }

      const query =
        normalize(input.value);

      invalidate();


      if (!query) {

        await showAllCities();

        return;
      }


      dropdown.innerHTML =
        '<div class="ozon-city-message">Loading...</div>';

      open();


      try {

        await loadCities();

        const matches =
          cities
            .filter(city =>
              normalize(city.name)
                .includes(query)
            )
            .slice(0, 100);

        render(matches);

      } catch (error) {

        dropdown.innerHTML =
          '<div class="ozon-city-message">Unable to load cities</div>';

        open();
      }
    }


    /* ---------- INPUT EVENTS ---------- */

    input.addEventListener(
      'focus',
      async () => {

        hideError();

        if (
          input.value.trim() &&
          input.dataset.ozonSelected !== '1'
        ) {

          await search();

        } else {

          await showAllCities();
        }
      }
    );


    input.addEventListener(
      'click',
      async () => {

        hideError();

        if (
          dropdown.classList.contains('open')
        ) {
          return;
        }

        await showAllCities();
      }
    );


    input.addEventListener(
      'input',
      async () => {

        if (selecting) {
          return;
        }

        hideError();

        await search();
      }
    );


    /* ---------- ARROW ---------- */

    arrow.addEventListener(
      'mousedown',
      async event => {

        event.preventDefault();
        event.stopPropagation();

        hideError();


        if (
          dropdown.classList.contains('open')
        ) {

          close();

          return;
        }


        await showAllCities();

        input.focus();
      }
    );


    /* ---------- KEYBOARD ---------- */

    input.addEventListener(
      'keydown',
      event => {

        const options =
          dropdown.querySelectorAll(
            '.ozon-city-option'
          );


        if (event.key === 'Escape') {

          close();

          return;
        }


        if (event.key === 'ArrowDown') {

          if (!options.length) {
            return;
          }

          event.preventDefault();

          active =
            active >= options.length - 1
              ? 0
              : active + 1;

        }

        else if (event.key === 'ArrowUp') {

          if (!options.length) {
            return;
          }

          event.preventDefault();

          active =
            active <= 0
              ? options.length - 1
              : active - 1;

        }

        else if (
          event.key === 'Enter' &&
          active >= 0
        ) {

          event.preventDefault();

          if (results[active]) {

            select(
              results[active]
            );
          }

          return;

        } else {

          return;
        }


        options.forEach(option => {

          option.classList.remove(
            'active'
          );

        });


        if (options[active]) {

          options[active]
            .classList.add(
              'active'
            );

          options[active]
            .scrollIntoView({
              block: 'nearest'
            });
        }
      }
    );


    /* ---------- CLICK OUTSIDE ---------- */

    document.addEventListener(
      'mousedown',
      event => {

        if (
          !wrapper.contains(
            event.target
          )
        ) {

          close();
        }
      }
    );


    /* Preload */

    loadCities().catch(() => {});
  }


  /* ==========================================
     FIND DYNAMIC FORM
     ========================================== */

  function find() {

    document
      .querySelectorAll(SELECTOR)
      .forEach(init);
  }


  find();


  /*
   Important:
   COD apps often inject their form after
   the page has already loaded.
  */

  const observer =
    new MutationObserver(() => {

      find();

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


  /* ==========================================
     VALIDATION
     ========================================== */

  function cityIsValid(input) {

    if (!input) {
      return true;
    }

    return Boolean(
      input.dataset.ozonSelected === '1' &&
      input.dataset.ozonCityId &&
      input.value.trim()
    );
  }


  function blockOrder(event, input) {

    if (!input) {
      return;
    }


    if (cityIsValid(input)) {
      return;
    }


    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    input.dataset.ozonSelected = '0';

    delete input.dataset.ozonCityId;
    delete input.dataset.ozonCityRef;
    delete input.dataset.ozonDeliveryPrice;


    const wrapper =
      input.closest(
        '.ozon-es-city-wrapper'
      );


    if (wrapper) {

      const error =
        wrapper.querySelector(
          '.ozon-city-error'
        );


      input.classList.add(
        'ozon-city-invalid'
      );


      input.setAttribute(
        'aria-invalid',
        'true'
      );


      if (error) {

        error.classList.add(
          'show'
        );
      }
    }


    input.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });


    input.focus();

    return false;
  }


  /* ==========================================
     BLOCK FORM SUBMISSION
     ========================================== */

  window.addEventListener(
    'submit',
    event => {

      const form =
        event.target;

      if (!form) {
        return;
      }


      const input =
        form.querySelector(
          SELECTOR
        );


      if (!input) {
        return;
      }


      if (!cityIsValid(input)) {

        blockOrder(
          event,
          input
        );
      }

    },
    true
  );


  /* ==========================================
     BLOCK ORDER BUTTON
     ========================================== */

  window.addEventListener(
    'click',
    event => {

      const button =
        event.target.closest(
          'button, input[type="submit"]'
        );


      if (!button) {
        return;
      }


      /*
       Never block our dropdown arrow.
      */

      if (
        button.classList.contains(
          'ozon-city-arrow'
        )
      ) {
        return;
      }


      const form =
        button.closest('form');


      if (!form) {
        return;
      }


      const input =
        form.querySelector(
          SELECTOR
        );


      if (!input) {
        return;
      }


      const type =
        String(
          button.getAttribute('type') || ''
        )
          .toLowerCase();


      const text =
        String(
          button.innerText ||
          button.value ||
          button.textContent ||
          ''
        )
          .toLowerCase()
          .trim();


      const isOrderButton =
        type === 'submit' ||
        text.includes('order now') ||
        text.includes('order') ||
        text.includes('commander') ||
        text.includes('commande');


      if (!isOrderButton) {
        return;
      }


      if (!cityIsValid(input)) {

        blockOrder(
          event,
          input
        );
      }

    },
    true
  );

})();